import React, { useEffect } from "react";
import PageOverView from "../components/Page Overview";
import Breadcrumb from "../components/BreadCrumb";
import WebDevelopment from './Tab/WebDevelopment';
import AI from './Tab/AI';
import DynamicsD365 from './Tab/DynamicsD365';
import './styles/Blogs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const text = "Blogs";

const paths = [
    { name: 'Home', link: '/' },
    { name: 'Blogs', link: '' },
];

const Blogs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className="page-overview">
                <PageOverView text={text} />
            </div>
            <div className="blogs-container">
                <Tabs>
                    <TabList>
                        <Tab>Web Development</Tab>
                        <Tab>AI</Tab>
                        <Tab>Dynamics 365</Tab>
                    </TabList>
                    <TabPanel>
                        <WebDevelopment />
                    </TabPanel>
                    <TabPanel>
                        <AI />
                    </TabPanel>
                    <TabPanel>
                        <DynamicsD365 />
                    </TabPanel>
                </Tabs>
            </div >
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};



export default Blogs;
